// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkButton--link--1y8BH"};